import React from 'react';
import Image from '@jetshop/ui/Image';

const Logo = ({ size = [400] }) => {
  const src = `/pub_images/original/logo-sidenselma.png`;
  return <Image src={src} sizes={size} aspect={'300:100'} crop={false} />;
};

export default Logo;
